'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Pager;
(function (Pager) {
    var MyPager = /** @class */ (function () {
        function MyPager() {
            var self = this;
            // ページャー機能
            var perPage, current;
            if ($('.paramNewsContent').length > 0) {
                var page = void 0;
                this.result = self.objResult();
                var resultCount_1 = self.getCountObj(this.result);
                if (perPage == null) {
                    perPage = 9;
                }
                if (current == null) {
                    current = 1;
                }
                self.writeHtmlPager(resultCount_1, perPage, current);
                // ページめくり
                $(document).on("click", '.trigPagerBtn', function () {
                    current = $(this).attr("data-page");
                    self.writeHtmlPager(resultCount_1, perPage, current);
                    // ページめくりを押した際に見出し位置まで移動
                    var position = $('.paramNewsTop').offset().top;
                    var headerHeight = $('.paramHeaderContent').outerHeight();
                    var movePosition = position - headerHeight;
                    var speed = 0;
                    $("html, body").animate({ scrollTop: movePosition }, speed, "linear");
                });
            }
        }
        // 検索結果をオブジェクトに格納
        MyPager.prototype.objResult = function () {
            var result = {};
            var I;
            for (var i = 0; i < $('.paramNewsContent').length; i++) {
                I = i + 1;
                result[I] = $('.paramNewsContent').eq(i);
            }
            return result;
        };
        // オブジェクトの個数を取得
        MyPager.prototype.getCountObj = function (obj) {
            var count = 0;
            Object.keys(obj).forEach(function (key) {
                count++;
            });
            return count;
        };
        // 検索結果数からページャーを生成
        MyPager.prototype.writeHtmlPager = function (total, perPage, current) {
            /**
            * total   件数合計
            * paePage 1ページに表示する件数
            * current 表示するページ番号
            * pages   ページ数
            * flag    F, B  "・・・"の表示判定 true のとき表示あり
            * body    結果 HTML ソース
            * pagerMargin  カレントページの前後に入れるページ番号の数
            */
            var pagerMargin;
            if (pagerMargin == null) {
                pagerMargin = 3;
            }
            var body = '';
            total = Number(total);
            perPage = Number(perPage);
            current = Number(current);
            // データがあれば実行
            if (total > 0) {
                var pageNumber = Number(total / perPage);
                var pages = Math.floor(total / perPage);
                // 割り切れていない場合、次のページを追加
                if (!this.isInteger(pageNumber)) {
                    pages++;
                }
                var flagF = void 0, flagB = void 0;
                if (pages <= (pagerMargin * 2) + 1) {
                    flagF = false;
                    flagB = false;
                }
                else {
                    if (current < 1) {
                        current = 1;
                    }
                    if (current <= pagerMargin + 2) {
                        flagF = false;
                    }
                    else {
                        flagF = true;
                    }
                    if (current >= pages - (pagerMargin + 1)) {
                        flagB = false;
                    }
                    else {
                        flagB = true;
                    }
                }
                // 最初P
                if (current == 1) {
                    body += '<li class="pager__navi__list active">1</li>';
                }
                else {
                    body += '<li class="pager__navi__list trigPagerBtn" data-page="1">1</li>';
                }
                // ・・・前
                if (flagF) {
                    body += '<li class="pager__navi__list dots"><i class="fa fa-ellipsis-h"></i></li>';
                }
                for (var i = 2; i <= pages - 1; i++) {
                    if (i >= current - pagerMargin && i <= current + pagerMargin) {
                        if (i == current) {
                            body += '<li class="pager__navi__list active">' + i + '</li>';
                        }
                        else {
                            body += '<li class="pager__navi__list trigPagerBtn" data-page="' + i + '">' + i + '</li>';
                        }
                    }
                }
                // 後ろ
                if (flagB) {
                    body += '<li class="pager__navi__list dots"><i class="fa fa-ellipsis-h"></i></li>';
                }
                // 最終P
                if (pages > 1) {
                    if (current == pages) {
                        body += '<li class="pager__navi__list active">' + pages + '</li>';
                    }
                    else {
                        body += '<li class="pager__navi__list trigPagerBtn" data-page="' + pages + '">' + pages + '</li>';
                    }
                }
                var last = pages;
                var prev = current - 1;
                if (prev < 1) {
                    prev = 1;
                }
                var next = current + 1;
                if (next > pages) {
                    next = pages;
                }
                $('.bulletPagerPrev').attr("data-page", prev);
                $('.bulletPagerNext').attr("data-page", next);
                $('.bulletPagerLast').attr("data-page", last);
            }
            // HTML を出力
            $('.bulletPagerNavi').html(body);
            // ○○-○○件目 を表示しています。
            var viewStart = (current - 1) * perPage + 1;
            var viewLast = current * perPage;
            if (viewLast > total) {
                viewLast = total;
            }
            // 検索結果リスト
            this.writeHtmlResult(this.result, viewStart, viewLast);
        };
        // ページャー操作で結果リストを生成
        MyPager.prototype.writeHtmlResult = function (result, start, end) {
            if (start > 0 && end > 0 && start <= end) {
                $('.paramNewsContent').remove();
                $.each(result, function (k, v) {
                    if (k >= start && k <= end) {
                        $('.bulletNewsContent').append(v);
                    }
                });
            }
        };
        MyPager.prototype.isInteger = function (x) {
            return Math.round(x) === x;
        };
        return MyPager;
    }());
    Pager.MyPager = MyPager;
})(Pager || (Pager = {}));
exports.default = Pager;
